import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { Home } from "./components/Home/Home";
import { About } from "./components/about";
import { Navigation } from "./components/navigation";

import { MultiSpeciesPage } from "./components/MultiSpecies/MultiSpeciesPage";
import { SpeciesDetails } from "./components/Details/SpeciesDetails";

import { EventsPage } from "./components/Events/EventsPage";
import { EventDetails } from "./components/Details/EventDetails";
import { DiscoveryPlanner } from "./components/Planner/DiscoveryPlanner";
import { ApiDocsPage } from "./components/Docs/ApiDocsPage";

import { HotspotsPage } from "./components/Hotspots/HotspotsPage";
import { HotspotDetails } from "./components/Details/HotspotDetails";
import "./App.css";
import 'mapbox-gl/dist/mapbox-gl.css';

import JsonData from "./data/data.json";
import { readDiscoveryTheme } from './lib/discoveryThemes';
import { APP_LAST_UPDATED, APP_VERSION } from './lib/releaseMeta';

const AppShell = ({ lat, lng, landingPageData }) => {
  const location = useLocation();
  const activeTheme = readDiscoveryTheme(location.search);

  return (
    <div className={`tellus-app-shell tellus-theme--${activeTheme}`}>
      <Navigation />
      <main className="tellus-main">
        <Routes>
          <Route exact path="/" element={<Home lat={lat} lng={lng} />} />
          <Route exact path="/planner" element={<DiscoveryPlanner lat={lat} lng={lng} />} />
          <Route exact path="/about" element={<About data={landingPageData.About} />} />
          <Route exact path="/docs" element={<ApiDocsPage />} />
          <Route exact path="/events" element={<EventsPage lat={lat} lng={lng} />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route exact path="/hotspots" element={<HotspotsPage lat={lat} lng={lng} />} />
          <Route path="/hotspots/:id" element={<HotspotDetails />} />
          <Route exact path="/species" element={<MultiSpeciesPage lat={lat} lng={lng} />} />
          <Route path="/species/:id" element={<SpeciesDetails />} />
        </Routes>
      </main>
      <footer className="atlas-release-bar">
        <span>Tellus v{APP_VERSION}</span>
        <span>Updated {APP_LAST_UPDATED}</span>
      </footer>
    </div>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    setLandingPageData(JsonData);

    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      setLat(position.coords.latitude);
      setLng(position.coords.longitude);
    });
  }, []);

  return (
    <BrowserRouter>
      <AppShell lat={lat} lng={lng} landingPageData={landingPageData} />
    </BrowserRouter>
  );
};

export default App;
